import {useMemo} from "react";
import _get from 'lodash/get';

/**
 * Handles any overriding properties for block settings that relate to lists
 *
 * @param props The props of the block, plus `items` and optionally `itemsPositions`
 * @param fieldName The name of the field the list is stored under. Defaults to `items`
 * @returns {*}
 */
const useApplyUserDefinedListOverrides = (props, fieldName = 'items') => {
    const items = props.items || [];
    const positions = props.itemsPositions ?? _get(props.values, `${fieldName}Positions`) ?? [];
    return useMemo(() => {
        const filtered = items.filter(item => !item?.isDeleted);
        if (filtered?.length && positions?.length) {
            filtered.sort((a, b) => positions.indexOf(a.id) - positions.indexOf(b.id));
        }

        return {
            ...props.values,
            [fieldName]: filtered
        };
    }, [items, positions, props.values]);
};

export default useApplyUserDefinedListOverrides;